import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

/**
 * useSetPasswordHook (DEPRECATED)
 *
 * Password setup links are no longer part of the customer auth flow.
 * Redirect users to the App Web code-only sign-in surface.
 */
export const useSetPasswordHook = () => {
  const navigate = useNavigate();

  const [isSubmitting] = useState(false);
  const [formData] = useState({ password: "", confirmPassword: "" });
  const [errors] = useState<{ password?: string; confirmPassword?: string }>(
    {}
  );
  const [hasValidSession] = useState(false);
  const [isCheckingSession, setIsCheckingSession] = useState(true);

  useEffect(() => {
    const appUrl =
      process.env.REACT_APP_APP_HOME_URL || "https://app.pedagogue.io";
    const params = new URLSearchParams(window.location.search);
    const email = params.get("email");
    const destination = email
      ? `${appUrl}/welcome?email=${encodeURIComponent(email)}&plan=PREMIUM`
      : `${appUrl}/login`;
    window.location.href = destination;
    setIsCheckingSession(false);
  }, [navigate]);

  const handleChange = () => {
    // No-op — redirecting to app.pedagogue.io
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // No-op — redirecting to app.pedagogue.io
  };

  return {
    formData,
    errors,
    isSubmitting,
    isCheckingSession,
    hasValidSession,
    handleChange,
    handleSubmit,
  };
};
